import {
  type AbstractMesh,
  type AssetContainer,
  TransformNode,
} from '@babylonjs/core';

import getParentMeshes from './get-parent-meshes.js';

const getAllMeshes = (assetContainer: AssetContainer): AbstractMesh[] => {
  const allMeshes: Record<string, AbstractMesh> = {};

  for (const mesh of assetContainer.meshes) {
    allMeshes[mesh.id] = mesh;
  }

  const collectMeshesRecursively = (node: TransformNode) => {
    const childMeshes = node.getChildMeshes();
    for (const mesh of childMeshes) {
      allMeshes[mesh.id] = mesh;
    }

    const childTransformNodes = node.getChildTransformNodes();
    for (const childNode of childTransformNodes) {
      collectMeshesRecursively(childNode);
    }

    const children = node.getChildren();
    for (const child of children) {
      if (child instanceof TransformNode) {
        collectMeshesRecursively(child);
      }
    }
  };

  for (const node of assetContainer.transformNodes) {
    collectMeshesRecursively(node);
  }

  for (const mesh of Object.values(allMeshes)) {
    getParentMeshes(mesh, allMeshes);
  }

  return Object.values(allMeshes);
};

export default getAllMeshes;
